(function () {
  "use strict";
  /* build: swipe-carousels-v2 */

  var SMYLA = window.SMYLA || {};
  var routes = SMYLA.routes || {
    cart_add_url: "/cart/add",
    cart_change_url: "/cart/change",
    cart_url: "/cart",
  };

  /* ---------------- Money formatting (Shopify-style) ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var fmt = format || SMYLA.moneyFormat || "{{amount}}";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(num, precision) {
      return (num / 100.0).toFixed(precision);
    }
    function thousands(num, precision, thousandsSep, decimalSep) {
      if (isNaN(num) || num == null) return 0;
      precision = precision == null ? 2 : precision;
      thousandsSep = thousandsSep == null ? "," : thousandsSep;
      decimalSep = decimalSep == null ? "." : decimalSep;
      var fixed = (Math.abs(num) / 100.0).toFixed(precision);
      var parts = fixed.split(".");
      var dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousandsSep
      );
      var centsPart = parts[1] ? decimalSep + parts[1] : "";
      return dollars + centsPart;
    }

    var match = fmt.match(placeholderRegex);
    var placeholder = match ? match[1] : "amount";
    switch (placeholder) {
      case "amount":
        value = thousands(cents, 2, ",", ".");
        break;
      case "amount_no_decimals":
        value = thousands(cents, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        value = thousands(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = thousands(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = thousands(cents, 2, " ", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = thousands(cents, 0, " ", ",");
        break;
      default:
        value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  /* ---------------- Small inline icons for JS-rendered cart ---------------- */
  var ICON = {
    minus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>',
    bag: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 10a4 4 0 0 1-8 0"/><path d="M3.103 6.034h17.794"/><path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"/></svg>',
    shield:
      '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
  };

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ============================================================
     MENU DRAWER
  ============================================================ */
  function initMenu() {
    var backdrop = qs("[data-menu-backdrop]");
    if (!backdrop) return;
    function open() {
      backdrop.hidden = false;
      document.body.style.overflow = "hidden";
    }
    function close() {
      backdrop.hidden = true;
      document.body.style.overflow = "";
    }
    qsa("[data-menu-open]").forEach(function (b) {
      b.addEventListener("click", open);
    });
    qsa("[data-menu-close]").forEach(function (b) {
      b.addEventListener("click", close);
    });
    backdrop.addEventListener("click", function (e) {
      if (e.target === backdrop) close();
    });
  }

  /* ============================================================
     ACCORDIONS (FAQ + info)
  ============================================================ */
  function initAccordions() {
    qsa("[data-accordion]").forEach(function (group) {
      var triggers = qsa("[data-accordion-trigger]", group);
      triggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var panel = trigger.parentElement.querySelector(
            "[data-accordion-panel]"
          );
          var isOpen = trigger.getAttribute("aria-expanded") === "true";
          // close others in the same group
          triggers.forEach(function (t) {
            if (t !== trigger) {
              t.setAttribute("aria-expanded", "false");
              var p = t.parentElement.querySelector("[data-accordion-panel]");
              if (p) p.hidden = true;
            }
          });
          trigger.setAttribute("aria-expanded", String(!isOpen));
          if (panel) panel.hidden = isOpen;
        });
      });
    });
  }

  /* ============================================================
     PRODUCT GALLERY
  ============================================================ */
  function initGallery() {
    var root = qs("[data-gallery]");
    if (!root) return;
    var dataEl = qs("[data-gallery-data]", root);
    var mainImg = qs("[data-gallery-image]", root);
    var countEl = qs("[data-gallery-count]", root);
    var thumbs = qsa("[data-gallery-thumb]", root);
    var slides = [];
    try {
      slides = JSON.parse(dataEl.textContent);
    } catch (e) {
      slides = [];
    }
    if (!slides.length || !mainImg) return;
    var active = 0;

    function show(index) {
      active = (index + slides.length) % slides.length;
      var slide = slides[active];
      mainImg.src = slide.src;
      mainImg.alt = slide.alt || "";
      mainImg.className = slide.fit === "contain" ? "contain" : "cover";
      if (countEl) countEl.textContent = active + 1 + " / " + slides.length;
      thumbs.forEach(function (t, i) {
        t.classList.toggle("active", i === active);
      });
    }

    var prev = qs("[data-gallery-prev]", root);
    var next = qs("[data-gallery-next]", root);
    if (prev) prev.addEventListener("click", function () { show(active - 1); });
    if (next) next.addEventListener("click", function () { show(active + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        show(parseInt(t.getAttribute("data-gallery-thumb"), 10) || 0);
      });
    });

    // Touch swipe on the main image (mobile UX)
    var main = qs(".gallery-main", root);
    if (main) {
      var startX = 0;
      var startY = 0;
      main.addEventListener(
        "touchstart",
        function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        },
        { passive: true }
      );
      main.addEventListener(
        "touchend",
        function (e) {
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          // horizontal swipe only (ignore vertical scrolls)
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
            show(active + (dx < 0 ? 1 : -1));
          }
        },
        { passive: true }
      );
    }
  }

  /* ============================================================
     BEFORE / AFTER SLIDER
  ============================================================ */
  function initBeforeAfter() {
    var root = qs("[data-before-after]");
    if (!root) return;
    var range = qs("[data-ba-range]", root);
    var after = qs("[data-ba-after]", root);
    var line = qs("[data-ba-line]", root);
    if (!range) return;
    function update() {
      var pos = Number(range.value);
      if (after) after.style.clipPath = "inset(0 " + (100 - pos) + "% 0 0)";
      if (line) line.style.left = pos + "%";
    }
    range.addEventListener("input", update);
    update();
  }

  /* ============================================================
     UGC VIDEOS
  ============================================================ */
  function initUGC() {
    var track = qs("[data-ugc]");
    if (!track) return;

    qsa(".ugc-card", track).forEach(function (card) {
      var video = qs("[data-ugc-video]", card);
      var playBtn = qs("[data-ugc-play]", card);
      var muteBtn = qs("[data-ugc-mute]", card);
      if (!video) return;

      // Always-on: all videos autoplay muted and loop continuously.
      video.muted = true;
      video.loop = true;
      var tryPlay = function () {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };
      tryPlay();
      video.addEventListener("canplay", tryPlay);
      video.addEventListener("loadeddata", tryPlay);

      // Some mobile browsers auto-pause videos on scroll; keep them playing
      // unless the visitor deliberately paused, or the tab is hidden.
      video.addEventListener("pause", function () {
        if (!video.dataset.userPaused && document.visibilityState === "visible") {
          tryPlay();
        }
      });
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "visible" && !video.dataset.userPaused) {
          tryPlay();
        }
      });

      function syncLabel() {
        if (playBtn)
          playBtn.setAttribute(
            "aria-label",
            video.paused ? "Lire la vidéo" : "Mettre en pause"
          );
      }
      if (playBtn)
        playBtn.addEventListener("click", function () {
          if (video.paused) {
            delete video.dataset.userPaused;
            tryPlay();
          } else {
            video.dataset.userPaused = "1";
            video.pause();
          }
          syncLabel();
        });
      if (muteBtn)
        muteBtn.addEventListener("click", function () {
          video.muted = !video.muted;
          if (!video.muted) tryPlay();
          muteBtn.setAttribute(
            "aria-label",
            video.muted ? "Activer le son" : "Couper le son"
          );
        });
      video.addEventListener("play", syncLabel);
    });
  }

  /* ============================================================
     STICKY BUY BAR
  ============================================================ */
  function initSticky() {
    var bar = qs("[data-sticky-buy]");
    if (!bar) return;
    var mainCta = qs("[data-add-to-cart]");

    // Preferred: show the sticky bar as soon as the inline CTA scrolls out of
    // view (upward), and keep it visible all the way down — maximises the
    // number of screens where "add to cart" is one tap away.
    if (mainCta && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          var scrolledPast = e.boundingClientRect.top < 0 && !e.isIntersecting;
          bar.hidden = !scrolledPast;
        },
        { threshold: 0 }
      );
      io.observe(mainCta);
      return;
    }

    // Fallback: scroll-based, no upper cutoff so it stays available.
    function onScroll() {
      bar.hidden = !(window.scrollY > 700);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     VARIANT PICKER
  ============================================================ */
  function initVariants() {
    var picker = qs("[data-variant-picker]");
    if (!picker) return;
    var radios = qsa("[data-variant-radio]", picker);
    var currentPrice = qs("[data-current-price]");
    var comparePrice = qs("[data-compare-price]");
    var savings = qs("[data-savings]");
    var ctaPrice = qs("[data-cta-price]");
    var stickyPrice = qs("[data-sticky-price]");
    var addBtn = qs("[data-add-to-cart]");
    var addLabel = qs("[data-add-label]");

    function selectRadio(radio) {
      var price = radio.getAttribute("data-price");
      var priceRaw = parseInt(radio.getAttribute("data-price-raw"), 10);
      var compareRaw = parseInt(radio.getAttribute("data-compare-raw"), 10) || 0;
      var available = radio.getAttribute("data-available") === "true";

      if (currentPrice) currentPrice.textContent = price;
      if (ctaPrice) ctaPrice.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;

      if (comparePrice) {
        if (compareRaw > priceRaw) {
          comparePrice.textContent = formatMoney(compareRaw);
          comparePrice.style.display = "";
          if (savings) {
            savings.textContent = "Économie " + formatMoney(compareRaw - priceRaw);
            savings.style.display = "";
          }
        } else {
          comparePrice.style.display = "none";
          if (savings) savings.style.display = "none";
        }
      }

      qsa(".variant-option", picker).forEach(function (label) {
        label.classList.remove("active");
      });
      radio.closest(".variant-option").classList.add("active");

      if (addBtn) {
        addBtn.disabled = !available;
        if (addLabel && !available)
          addLabel.textContent = SMYLA.strings ? SMYLA.strings.soldOut : "Épuisé";
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        if (radio.checked) selectRadio(radio);
      });
    });
  }

  /* ============================================================
     CART
  ============================================================ */
  function initCart() {
    var backdrop = qs("[data-cart-backdrop]");
    var body = qs("[data-cart-body]");

    function openDrawer() {
      if (!backdrop) return;
      backdrop.hidden = false;
      document.body.style.overflow = "hidden";
    }
    function closeDrawer() {
      if (!backdrop) return;
      backdrop.hidden = true;
      document.body.style.overflow = "";
    }

    // open/close triggers (delegated so it also works after re-render)
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-open]")) {
        e.preventDefault();
        openDrawer();
        refreshCart();
      }
      if (e.target.closest("[data-cart-close]")) {
        e.preventDefault();
        closeDrawer();
      }
    });
    if (backdrop)
      backdrop.addEventListener("click", function (e) {
        if (e.target === backdrop) closeDrawer();
      });

    function updateCount(count) {
      qsa("[data-cart-count]").forEach(function (el) {
        el.textContent = count;
      });
    }

    function renderCart(cart) {
      updateCount(cart.item_count);
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="empty">' +
          ICON.bag +
          "<h3>Tu carrito está vacío</h3>" +
          '<button class="outline-cta" data-cart-close>Seguir comprando</button>' +
          "</div>";
        return;
      }
      // Bundle value-stack: derived from the real Shopify variant title.
      var BUNDLES = {
        Essentiel: { base: 14, offered: 0, total: 14, gifts: false, featured: false },
        Esencial: { base: 14, offered: 0, total: 14, gifts: false, featured: false },
        "Le plus choisi": { base: 42, offered: 14, total: 56, gifts: true, featured: true },
        "El más elegido": { base: 42, offered: 14, total: 56, gifts: true, featured: true },
        "Routine complète": { base: 84, offered: 28, total: 112, gifts: true, featured: false },
        "Rutina completa": { base: 84, offered: 28, total: 112, gifts: true, featured: false },
      };
      var CHECK =
        '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

      var html = "";
      cart.items.forEach(function (item) {
        var variantTitle =
          item.variant_title && item.variant_title.indexOf("Default") === -1
            ? item.variant_title
            : "";
        var b = BUNDLES[item.variant_title] || null;

        var compo = "";
        if (b) {
          compo =
            '<span class="cd-compo">' +
            b.base +
            " tiras" +
            (b.offered
              ? '<i class="cd-plus">+ ' + b.offered + " de regalo</i>"
              : "") +
            "</span>";
        }
        var gifts = "";
        if (b && b.gifts) {
          gifts =
            '<ul class="cd-gifts">' +
            "<li>" + CHECK + "Cepillo pro de regalo</li>" +
            "<li>" + CHECK + "Regalo sorpresa</li>" +
            "<li>" + CHECK + "Envío gratis</li>" +
            "</ul>";
        }

        html +=
          '<div class="cart-product">' +
          '<img src="' + (item.image || SMYLA.fallbackImage || "") + '" alt="">' +
          "<div>" +
          "<strong>" + item.product_title + "</strong>" +
          '<span class="cd-variant">' +
          (b ? "Rutina de " + b.total + " tiras" : variantTitle) +
          (b && b.featured ? '<em class="cd-badge">El más elegido</em>' : "") +
          "</span>" +
          compo +
          gifts +
          "<b>" + formatMoney(item.final_price) + "</b>" +
          '<div class="quantity">' +
          '<button type="button" data-qty-down data-key="' + item.key + '" aria-label="Reducir la cantidad">' +
          ICON.minus +
          "</button>" +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-qty-up data-key="' + item.key + '" aria-label="Aumentar la cantidad">' +
          ICON.plus +
          "</button>" +
          "</div>" +
          "</div>" +
          "</div>";
      });

      html +=
        '<div class="subtotal"><span>Subtotal</span><strong>' +
        formatMoney(cart.total_price) +
        "</strong></div>" +
        '<div class="cd-ship"><span>Envío</span><b>Gratis</b></div>' +
        '<a class="main-cta" href="/checkout" data-checkout>Pagar mi pedido — ' +
        formatMoney(cart.total_price) +
        "</a>" +
        '<small class="checkout-note">' +
        ICON.shield +
        " Pago seguro · Tus datos están protegidos</small>" +
        '<div class="cd-trust">' +
        "<span>" + ICON.shield + "Pago seguro</span>" +
        "<span>" + CHECK + "Envío gratis</span>" +
        "</div>" +
        '<a class="cd-detail" href="' + routes.cart_url + '">Ver el detalle de mi pedido</a>';
      body.innerHTML = html;
    }

    function refreshCart() {
      fetch(routes.cart_url + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {});
    }

    function changeQty(key, quantity) {
      fetch(routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {});
    }

    // delegated qty buttons
    document.addEventListener("click", function (e) {
      var up = e.target.closest("[data-qty-up]");
      var down = e.target.closest("[data-qty-down]");
      if (up || down) {
        var btn = up || down;
        var key = btn.getAttribute("data-key");
        var span = btn.parentElement.querySelector("span");
        var current = parseInt(span.textContent, 10) || 0;
        changeQty(key, up ? current + 1 : Math.max(0, current - 1));
      }
    });

    // ADD TO CART
    var form = document.getElementById("product-form") || qs("[data-product-form]");
    function addToCart() {
      if (!form) return;
      var formData = new FormData(form);
      var btn = qs("[data-add-to-cart]", form);
      if (btn) btn.disabled = true;
      fetch(routes.cart_add_url + ".js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) btn.disabled = false;
          openDrawer();
          refreshCart();
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          // fallback: native submit
          form.submit();
        });
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        addToCart();
      });
    }
    var stickyAdd = qs("[data-sticky-add]");
    if (stickyAdd)
      stickyAdd.addEventListener("click", function () {
        addToCart();
      });
  }

  /* ============================================================
     SWIPE CAROUSELS (drag-to-scroll) — UGC videos + routine steps
     Native touch-scroll fails when the finger lands on a <video>
     or image, so we drive scrollLeft manually from touch/mouse.
  ============================================================ */
  function enableDragScroll(el) {
    var isDown = false,
      startX = 0,
      startY = 0,
      startLeft = 0,
      decided = false,
      horizontal = false,
      moved = false;

    // NOTE: touch is handled by the browser's native horizontal scroll
    // (smooth + momentum on iOS). We only add mouse dragging below so the
    // carousel is also draggable with a mouse on desktop / editor preview.

    // Mouse (desktop drag)
    el.addEventListener("mousedown", function (e) {
      isDown = true;
      moved = false;
      startX = e.clientX;
      startLeft = el.scrollLeft;
      el.classList.add("is-grabbing");
    });
    window.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startLeft - dx;
      if (moved) e.preventDefault();
    });
    window.addEventListener("mouseup", function () {
      if (isDown) {
        isDown = false;
        el.classList.remove("is-grabbing");
      }
    });

    // Swallow the click that follows a drag so it can't toggle a video
    el.addEventListener(
      "click",
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function initSwipeCarousels() {
    var carousels = qsa(".ugc-track").concat(qsa(".step-grid")).concat(qsa(".dd-res-track"));
    carousels.forEach(function (el) {
      enableDragScroll(el);
    });
  }

  /* ============================================================
     STOCK COUNTDOWN — evergreen 4h timer under the availability bar.
     Persists per visitor (localStorage) so it keeps counting across
     page loads, and restarts at 4h when it reaches zero.
  ============================================================ */
  function initCountdown() {
    var el = qs("[data-countdown-time]");
    if (!el) return;
    var DURATION = 4 * 60 * 60 * 1000; // 4 hours in ms
    var KEY = "smyla_countdown_end";

    function pad(n) {
      return n < 10 ? "0" + n : "" + n;
    }
    function readEnd() {
      var v = 0;
      try {
        v = parseInt(localStorage.getItem(KEY), 10);
      } catch (e) {}
      var now = Date.now();
      if (!v || isNaN(v) || v <= now) {
        v = now + DURATION;
        try {
          localStorage.setItem(KEY, String(v));
        } catch (e) {}
      }
      return v;
    }

    var end = readEnd();
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        end = Date.now() + DURATION;
        try {
          localStorage.setItem(KEY, String(end));
        } catch (e) {}
        diff = DURATION;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ============================================================
     BUNDLE SELECTOR — premium pack picker wired to the real cart.
     Selecting a card checks its <input name="id"> (native <label>),
     so the product form always submits the chosen variant. We only
     mirror the price into the headline / CTA / sticky bar and fire
     lightweight tracking into whatever analytics layer already exists.
  ============================================================ */
  function track(event, payload) {
    try {
      var data = payload || {};
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: event }, data));
      }
      if (typeof window.gtag === "function") {
        window.gtag("event", event, data);
      }
      if (typeof window.fbq === "function") {
        window.fbq("trackCustom", event, data);
      }
    } catch (e) {}
  }

  function initBundles() {
    var root = qs("[data-bundles]");
    if (!root) return;
    var cards = qsa("[data-bundle]", root);
    if (!cards.length) return;

    var currentPrice = qs("[data-current-price]");
    var ctaPrice = qs("[data-cta-price]");
    var stickyPrice = qs("[data-sticky-price]");

    function payloadFor(card) {
      return {
        bundle: card.getAttribute("data-name"),
        variant_id: (qs(".bundle-radio", card) || {}).value,
        bands: parseInt(card.getAttribute("data-total"), 10) || null,
        price: (parseInt(card.getAttribute("data-price"), 10) || 0) / 100,
      };
    }

    function select(card, fireEvent) {
      var money = card.getAttribute("data-price-money");
      cards.forEach(function (c) {
        c.classList.toggle("is-selected", c === card);
      });
      if (currentPrice) currentPrice.textContent = money;
      if (ctaPrice) ctaPrice.textContent = money;
      if (stickyPrice) stickyPrice.textContent = money;
      // Libelle du CTA porte par la carte : reste synchronise avec l'offre choisie.
      var ctaText = qs("[data-cta-text]");
      var label = card.getAttribute("data-cta-label");
      if (ctaText && label) ctaText.textContent = label;
      if (fireEvent) track("bundle_select", payloadFor(card));
    }

    cards.forEach(function (card) {
      var radio = qs(".bundle-radio", card);
      if (!radio) return;
      radio.addEventListener("change", function () {
        if (radio.checked) select(card, true);
      });
    });

    // Sync visuals to whichever card is checked on load (the featured one),
    // without firing a select event, then log the impression.
    var checked = cards.filter(function (c) {
      var r = qs(".bundle-radio", c);
      return r && r.checked;
    })[0];
    if (checked) select(checked, false);
    track("bundle_view", {
      bundles: cards.map(function (c) {
        return c.getAttribute("data-name");
      }),
    });

    // Tag the add-to-cart with the selected bundle for downstream tracking.
    var form = document.getElementById("product-form");
    if (form) {
      form.addEventListener("submit", function () {
        var sel = cards.filter(function (c) {
          return c.classList.contains("is-selected");
        })[0];
        if (sel) track("bundle_add_to_cart", payloadFor(sel));
      });
    }
  }

  /* ============================================================
     REVIEW CAROUSEL ARROWS — scroll the client-reviews track by
     roughly one card per click (desktop nav; mobile uses swipe).
  ============================================================ */
  function initReviewArrows() {
    var track = qs("[data-dd-res-track]");
    if (!track) return;
    var prev = qs("[data-dd-res-prev]");
    var next = qs("[data-dd-res-next]");

    function step() {
      var card = qs(".dd-res-card", track);
      var w = card ? card.getBoundingClientRect().width : 300;
      return w + 22; // card width + gap
    }
    if (prev)
      prev.addEventListener("click", function () {
        track.scrollBy({ left: -step(), behavior: "smooth" });
      });
    if (next)
      next.addEventListener("click", function () {
        track.scrollBy({ left: step(), behavior: "smooth" });
      });
  }

  /* ============================================================
     STICKY SMART QUICK BUY — compact/expanded bar synced with the
     real product form (bundle radios are the single source of truth).
     Buy-now adds the selected variant then goes straight to checkout.
  ============================================================ */
  function initQuickBuy() {
    var sqb = qs("[data-sqb]");
    if (!sqb) return;
    var form = document.getElementById("product-form");
    if (!form) return;

    var mainRadios = qsa(".bundle-radio", form); // source of truth
    if (!mainRadios.length) return;
    var sqbBundles = qsa("[data-sqb-bundle]", sqb);
    var priceEls = qsa("[data-sqb-price]", sqb);
    var nameEls = qsa("[data-sqb-name]", sqb);
    var shippingEl = qs("[data-sqb-shipping]", sqb);
    var toggle = qs("[data-sqb-toggle]", sqb);
    var buyBtns = qsa("[data-sqb-buy]", sqb);
    var busy = false;

    function currentRadio() {
      return (
        mainRadios.filter(function (r) {
          return r.checked;
        })[0] || mainRadios[0]
      );
    }

    function syncFromMain() {
      var r = currentRadio();
      if (!r) return;
      var id = r.value;
      var btn = sqbBundles.filter(function (b) {
        return b.getAttribute("data-variant-id") === id;
      })[0];
      var money = btn ? btn.getAttribute("data-price-money") : "";
      var name = btn ? btn.getAttribute("data-name") : "";
      var shipping = btn ? btn.getAttribute("data-shipping") === "true" : false;
      priceEls.forEach(function (el) {
        el.textContent = money;
      });
      nameEls.forEach(function (el) {
        el.textContent = name;
      });
      sqbBundles.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      if (shippingEl) shippingEl.style.display = shipping ? "" : "none";
    }

    // Sticky bundle button -> drive the real form radio (keeps Shopify in sync)
    sqbBundles.forEach(function (b) {
      b.addEventListener("click", function () {
        var id = b.getAttribute("data-variant-id");
        var r = mainRadios.filter(function (x) {
          return x.value === id;
        })[0];
        if (r && !r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event("change", { bubbles: true }));
        }
        syncFromMain();
        track("sticky_bundle_select", { variant_id: id });
      });
    });

    // Main form change -> reflect in the sticky bar
    mainRadios.forEach(function (r) {
      r.addEventListener("change", function () {
        if (r.checked) syncFromMain();
      });
    });

    // Expand / collapse
    function setOpen(open) {
      sqb.classList.toggle("is-open", open);
      if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
    }
    if (toggle)
      toggle.addEventListener("click", function () {
        setOpen(!sqb.classList.contains("is-open"));
      });
    var collapse = qs("[data-sqb-collapse]", sqb);
    if (collapse)
      collapse.addEventListener("click", function () {
        setOpen(false);
      });

    // Buy now -> add to cart, then straight to checkout
    buyBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (busy) return;
        var r = currentRadio();
        if (!r) return;
        busy = true;
        track("sticky_add_to_cart", { variant_id: r.value });
        track("sticky_buy_now", { variant_id: r.value });
        var labelEl = qs("[data-sqb-buy-label]", btn);
        var restore = labelEl ? labelEl.innerHTML : btn.textContent;
        fetch(routes.cart_add_url + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: r.value, quantity: 1 }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error("add_failed");
            return res.json();
          })
          .then(function () {
            btn.classList.add("is-done");
            if (labelEl) labelEl.textContent = "✓ Añadido";
            else btn.textContent = "✓ Añadido";
            setTimeout(function () {
              window.location.href = "/checkout";
            }, 550);
          })
          .catch(function () {
            busy = false;
            btn.classList.add("is-error");
            if (labelEl) labelEl.textContent = "Reintentar";
            else btn.textContent = "Reintentar";
            setTimeout(function () {
              btn.classList.remove("is-error");
              if (labelEl) labelEl.innerHTML = restore;
              else btn.textContent = restore;
            }, 1600);
          });
      });
    });

    function reveal() {
      if (sqb.hidden) sqb.hidden = false;
      if (!sqb.dataset.viewed) {
        sqb.dataset.viewed = "1";
        track("sticky_quick_buy_view", {});
      }
    }

    var mainCta = qs("[data-add-to-cart]");
    var isMobile =
      window.matchMedia && window.matchMedia("(max-width: 767px)").matches;

    if (isMobile) {
      // Mobile: available from the first screen — no scroll required.
      reveal();
    } else if (mainCta && "IntersectionObserver" in window) {
      // Desktop: the buy column is sticky, so the main CTA can sit just below
      // a short viewport (e.g. 1366×768). Show the floating capsule whenever
      // the main CTA is NOT in view (above OR below the fold), hide it when the
      // main CTA is visible — so there is always exactly one visible CTA.
      var io = new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          if (e.isIntersecting) {
            sqb.hidden = true;
          } else {
            reveal();
          }
        },
        { threshold: 0 }
      );
      io.observe(mainCta);
    } else {
      reveal();
    }

    syncFromMain();
  }

  /* ============================================================
     TECH SECTION — reveal cards + dual-action animation on scroll
  ============================================================ */
  function initTechReveal() {
    var sec = qs("[data-tech]");
    if (!sec) return;
    if (!("IntersectionObserver" in window)) {
      sec.classList.add("is-in");
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            sec.classList.add("is-in");
            io.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    io.observe(sec);
  }


  /* ============================================================
     FOOTER ACCORDIONS (mobile) — real buttons, keyboard accessible
  ============================================================ */
  function initFooterAccordions() {
    var cols = qsa("[data-foot-col]");
    if (!cols.length) return;
    var mq = window.matchMedia("(max-width: 800px)");
    cols.forEach(function (col) {
      var btn = qs("[data-foot-toggle]", col);
      if (!btn) return;
      btn.addEventListener("click", function () {
        if (!mq.matches) return; // desktop: always open, header is not a toggle
        var open = col.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  }

  /* ============================================================
     COOKIE CONSENT — Shopify Customer Privacy API
     No third-party library. Nothing is pre-checked. Accept and
     Reject get equal visual weight (see CSS).
  ============================================================ */
  function initCookieConsent() {
    var banner = qs("[data-cookie-banner]");
    if (!banner) return;

    function api() {
      return window.Shopify && window.Shopify.customerPrivacy
        ? window.Shopify.customerPrivacy
        : null;
    }

    function show(prefsOpen) {
      banner.hidden = false;
      banner.classList.add("is-visible");
      if (prefsOpen) banner.classList.add("is-prefs");
      var btn = qs("[data-cookie-customize]", banner);
      if (btn && prefsOpen) btn.setAttribute("aria-expanded", "true");
    }
    function hide() {
      banner.classList.remove("is-visible", "is-prefs");
      banner.hidden = true;
    }

    function apply(consent) {
      var cp = api();
      if (cp && typeof cp.setTrackingConsent === "function") {
        try {
          cp.setTrackingConsent(consent, function () {});
        } catch (e) {}
      }
      try {
        localStorage.setItem("smyla_consent", JSON.stringify(consent));
      } catch (e) {}
      hide();
    }

    function allValue(v) {
      return { analytics: v, marketing: v, preferences: v, sale_of_data: v };
    }

    qsa("[data-cookie-accept]", banner).forEach(function (b) {
      b.addEventListener("click", function () { apply(allValue(true)); });
    });
    qsa("[data-cookie-reject]", banner).forEach(function (b) {
      b.addEventListener("click", function () { apply(allValue(false)); });
    });
    var custom = qs("[data-cookie-customize]", banner);
    if (custom) {
      custom.addEventListener("click", function () {
        var open = banner.classList.toggle("is-prefs");
        custom.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }
    var save = qs("[data-cookie-save]", banner);
    if (save) {
      save.addEventListener("click", function () {
        function on(sel) {
          var el = qs(sel, banner);
          return !!(el && el.checked);
        }
        apply({
          analytics: on("[data-cookie-analytics]"),
          marketing: on("[data-cookie-marketing]"),
          preferences: on("[data-cookie-preferences]"),
          sale_of_data: on("[data-cookie-marketing]"),
        });
      });
    }

    // "Gérer mes cookies" in the footer re-opens the panel
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cookie-open]")) {
        e.preventDefault();
        var saved = null;
        try { saved = JSON.parse(localStorage.getItem("smyla_consent")); } catch (err) {}
        if (saved) {
          var map = {
            "[data-cookie-analytics]": saved.analytics,
            "[data-cookie-marketing]": saved.marketing,
            "[data-cookie-preferences]": saved.preferences,
          };
          Object.keys(map).forEach(function (sel) {
            var el = qs(sel, banner);
            if (el) el.checked = !!map[sel];
          });
        }
        show(true);
      }
    });

    // Show on first visit only (no stored choice yet)
    var stored = null;
    try { stored = localStorage.getItem("smyla_consent"); } catch (e) {}
    if (!stored) {
      // Wait for Shopify's API when it is still loading
      if (api()) show(false);
      else {
        document.addEventListener("visitorConsentCollected", hide);
        setTimeout(function () { show(false); }, 800);
      }
    }
  }

  /* ============================================================
     CART SUMMARY — collapsible order recap (mobile)
  ============================================================ */
  function initCartSummary() {
    var toggle = qs("[data-ck-toggle]");
    if (!toggle) return;
    var box = toggle.closest(".ck-summary");
    if (!box) return;
    toggle.addEventListener("click", function () {
      var open = box.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ============================================================
     CONTACT FORM — submit state (prevents double submission)
  ============================================================ */
  function initContactForm() {
    var form = document.getElementById("contact-form");
    if (!form) return;
    var btn = qs("[data-cx-submit]", form);
    var label = qs("[data-cx-submit-label]", btn || form);
    if (!btn) return;
    var original = label ? label.textContent : "";
    form.addEventListener("submit", function () {
      if (!form.checkValidity()) return; // let the browser show field errors
      btn.disabled = true;
      if (label) label.textContent = "Enviando…";
      // Shopify's spam protection (hCaptcha) can delay or cancel the submit.
      // Never leave the visitor with a dead button: restore it if we're still here.
      setTimeout(function () {
        btn.disabled = false;
        if (label) label.textContent = original;
      }, 9000);
    });
  }

  /* ============================================================
     ABOUT PAGE — gentle reveal on scroll
  ============================================================ */
  function initAboutReveal() {
    var items = qsa(".ab-reveal");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var root = qs("[data-ab]");
    // Only now do we allow the CSS to hide things: if this JS never runs,
    // the content stays fully visible instead of disappearing.
    if (root) root.setAttribute("data-reveal-ready", "");
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  /* ============================================================
     ESTIMATION DE LIVRAISON — calcul en jours ouvrés, côté client.
     N'invente rien : si les délais de transport ne sont pas
     renseignés dans les settings, on n'affiche aucune date.
  ============================================================ */
  function initDeliveryEstimate() {
    var el = qs("[data-dd-eta]");
    if (!el) return;
    var out = qs("[data-dd-eta-text]", el);
    if (!out) return;

    var MONTHS = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];
    var num = function (v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; };

    var cutoff = num(el.getAttribute("data-cutoff"));
    var dispatch = num(el.getAttribute("data-dispatch"));
    if (dispatch === null) dispatch = 1;
    var minD = num(el.getAttribute("data-min"));
    var maxD = num(el.getAttribute("data-max"));
    var skipWeekend = el.getAttribute("data-skip-weekend") !== "false";

    function isWeekend(d) { var w = d.getDay(); return w === 0 || w === 6; }
    function addBusinessDays(from, n) {
      var d = new Date(from.getTime());
      var left = n;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        if (!skipWeekend || !isWeekend(d)) left--;
      }
      // si on tombe un week-end sans jour à ajouter, on décale au lundi
      while (skipWeekend && isWeekend(d)) d.setDate(d.getDate() + 1);
      return d;
    }
    function fmt(d) { return d.getDate() + " de " + MONTHS[d.getMonth()]; }

    var now = new Date();
    // Passée l'heure limite, la préparation démarre le jour ouvré suivant.
    var start = new Date(now.getTime());
    if (cutoff !== null && now.getHours() >= cutoff) start.setDate(start.getDate() + 1);

    var ship = addBusinessDays(start, dispatch);

    // Pas de délai de transport renseigné → on s'en tient à l'expédition.
    if (minD === null || maxD === null) {
      var shipTxt = cutoff !== null
        ? "Pide antes de las " + cutoff + " h → se envía el " + fmt(ship)
        : "Tu pedido se envía el " + fmt(ship);
      out.textContent = shipTxt;
      el.setAttribute("data-dd-eta-state", "dispatch-only");
      return;
    }

    var d1 = addBusinessDays(ship, minD);
    var d2 = addBusinessDays(ship, maxD);
    var range = d1.getMonth() === d2.getMonth()
      ? "entre el " + d1.getDate() + " y el " + fmt(d2)
      : "entre el " + fmt(d1) + " y el " + fmt(d2);

    out.textContent = (cutoff !== null ? "Pide antes de las " + cutoff + " h → entrega estimada " : "Entrega estimada ") + range;
    el.setAttribute("data-dd-eta-state", "full");
  }

  /* ---------------- init ---------------- */
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initMenu();
    initAccordions();
    initGallery();
    initBeforeAfter();
    initUGC();
    initSticky();
    initVariants();
    initBundles();
    initQuickBuy();
    initCart();
    initCartSummary();
    initContactForm();
    initAboutReveal();
    initDeliveryEstimate();
    initSwipeCarousels();
    initReviewArrows();
    initTechReveal();
    initCountdown();
    initFooterAccordions();
    initCookieConsent();
  });
})();
